class Stepper extends HTMLElement {
  static observedAttributes = ["step"]

  #step = 5

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== "step") {
      console.warn("Unknown attribute %s given value %s", name, newValue)
      return
    }
    const parsed = parseFloat(newValue)
    if (!isNaN(parsed) && parsed > 0) {
      this.#step = parsed
    }
  }

  #decrement = () => {
    const input = this.querySelector("input")
    const minimum = parseFloat(input.min) || 0
    const current = parseFloat(input.value) || 0
    input.value = Math.max(minimum, current - this.#step)
  }

  #increment = () => {
    const input = this.querySelector("input")
    const current = parseFloat(input.value) || 0
    input.value = current + this.#step
  }

  connectedCallback() {
    this.querySelector("[data-decrement]").addEventListener("click", this.#decrement)
    this.querySelector("[data-increment]").addEventListener("click", this.#increment)
  }
}

export default Stepper
